module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.row.subject_list,
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "yundongyuan",
      "label": "用户名",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s('项目' + (scope.$index + 1)) + "\n          "), _c('div', [_vm._v("运动员："), _vm._l((scope.row.yundongyuan), function(member, index) {
          return _c('el-tag', {
            key: index,
            staticClass: "mr10",
            attrs: {
              "round": "",
              "size": "small",
              "type": "primary"
            }
          }, [_vm._v("\n            " + _vm._s(member.name))])
        })], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subject_name",
      "label": "用户名",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.video.length == 0) ? _c('el-button', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'ISaiApplyFormUploadVideo',
              query: {
                id: scope.row.id
              }
            }),
            expression: "{name:'ISaiApplyFormUploadVideo',query:{ id: scope.row.id }}"
          }],
          attrs: {
            "size": "medium",
            "type": "primary"
          }
        }, [_vm._v("上传视频")]) : _c('el-button', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'ISaiApplyFormUploadVideo',
              query: {
                id: scope.row.id
              }
            }),
            expression: "{name:'ISaiApplyFormUploadVideo',query:{ id: scope.row.id }}"
          }],
          attrs: {
            "size": "medium",
            "readonly": ""
          }
        }, [_vm._v("视频已上传")])]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-257eaff2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyVideoList.vue
// module id = 1345
// module chunks = 0